<template>
  <div class="station-letter">
    <avue-crud :data="zhanneixinData" :option="TabOption" v-model="zhanneixinTab" :page="page"
      @search-change="searchChange" @size-change="sizeChange" @current-change="currentChange" @cell-click="rowEdit"
      :table-loading="loading" @search-reset="searchReset">

      <template slot-scope="scope" slot="menuLeft">
        <el-button type="danger" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增</el-button>
      </template>

      <template slot-scope="{row,index}" slot="menu">
        <el-button type="text" icon="el-icon-s-release" @click="unpublish(row,index)"
          v-if="row.publish_status*1">取消发布</el-button>
        <el-button type="text" icon="el-icon-s-promotion" @click="topublish(row,index)" v-else>发布</el-button>
      </template>

      <template slot-scope="scope" slot="publish_department_codeSearch">
        <el-select v-model="jgvalue" filterable placeholder="发布单位">
          <el-option v-for="item in jgoptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </template>
    </avue-crud>

    <!-- 发布弹框 -->
    <el-dialog :visible.sync="publicFlag" width="50%" append-to-body :center=true>
      <avue-form ref="publicform" v-model="fabudata" :option="fabuOption"></avue-form>
      <el-row :gutter="20" style="padding:0 30px">
        <el-form ref="form" label-width="80px">
          <el-col :span="12">
            <el-form-item label="接收人">
              <userSelect v-model="fabudata.user"></userSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接受角色">
              <roleSelect v-model="fabudata.role"></roleSelect>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="publicFlag = false">取 消</el-button>
        <el-button type="primary" @click="publishnow">发 布</el-button>
      </span>
    </el-dialog>

    <!-- 新增弹框 -->
    <el-dialog :visible.sync="addFlag" width="50%" :modal-append-to-body=false :center=true>
      <avue-form ref="addform" v-model="adddata" :option="addOption"></avue-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="addSaveData(adddata.id)">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchkey: null,
      publicFlag: false,
      addFlag: false,
      jgvalue: '',
      jgoptions: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },

      zhanneixinTab: {},
      zhanneixinData: [],
      TabOption: {
        title: '站内信列表',
        menuType: 'text',
        page: true,
        align: 'center',
        dateDefault: false,
        menuAlign: 'center',
        menu: true,
        refreshBtn: false,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        border: true,
        column: [
          {
            label: '标题',
            prop: 'title',
            search: true,
          },
          {
            label: "开始时间",
            prop: "start_time",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",

          },
          {
            label: "结束时间",
            prop: "end_time",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd"
          },
          {
            label: '发布人',
            prop: 'publish_user',
            search: true
          },
          {
            label: '接收人',
            prop: 'rec_name_list'
          },
          {
            label: '接受角色',
            prop: 'rec_role_list'
          },
          {
            label: '发布单位',
            prop: 'publish_department_code',
            searchslot: true,
            search: true,
            hide: true
          },
          {
            label: '发布状态',
            prop: 'publish_status',
            type: 'select',
            search: true,
            hide: true,
            dicData: [
              {
                label: '已发布',
                value: 1
              },
              {
                label: '未发布',
                value: 0
              }
            ]
          }
        ]
      },

      fabudata: {
        user: [],
        role: [],
      },
      fabuOption: {
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "标题",
            prop: "title",
            span: 24,
            readonly: true
          },
          {
            label: "开始时间",
            prop: "start_time",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "请选择开始时间",
              trigger: "change"
            }]
          },
          {
            label: "结束时间",
            prop: "end_time",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "请选择结束时间",
              trigger: "change"
            }]
          }
        ]
      },

      adddata: {},
      addOption: {
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "标题",
            prop: "title",
            span: 24,
            rules: [{
              required: true,
              message: "标题必须填写",
              trigger: "blur"
            }],
          },
          {
            label: "描述",
            prop: "text",
            type: "textarea",
            span: 24,
            rules: [{
              required: true,
              message: "描述必须填写",
              trigger: "blur"
            }],

          }
        ]
      }
    }
  },
  methods: {
    handleEmpty() {
      this.$refs.form.resetForm();
    },
    // 发布弹出框
    topublish(row, index) {
      this.publicFlag = true;
      this.fabudata = this.$options.data().fabudata;

      this.fabudata.title = row.title;
      this.fabudata.id = row.id;

    },
    // 确认发布
    publishnow() {

      let start_time = this.crtTimeFtt(this.fabudata.start_time);
      let end_time = this.crtTimeFtt(this.fabudata.end_time);
      // 接收人id
      let rec_id_list = this.fabudata.user.map(e => {
        return e.id
      }).join()
      // 角色id
      let rec_roleid_list = this.fabudata.role.map(e => {
        return e.id
      }).join()
      let fabudata = { start_time, end_time, rec_id_list, rec_roleid_list, id: this.fabudata.id };
      // console.log(fabudata);

      this.$refs.publicform.validate((valid) => {
        if (valid) {
          this.publicFlag = false;
          this.$http.put("/message/publish", null, {
            params: fabudata
          }).then(res => {
            this.onLoad("", "", this.searchkey);
            this.$message.success(res.msg);
            Object.assign(this.fabudata, { start_time: null, end_time: null, user: null, role: null });
          }).catch(error => {
            this.$message.error(error.msg);
            this.$Log.capsule('发布失败', error, 'danger');
            Object.assign(this.fabudata, { start_time: null, end_time: null, user: null, role: null });
          })
        } else {
          return false;
        }
      });



    },
    handleAdd() {
      this.adddata.title = "";
      this.adddata.text = "";
      this.addFlag = true;
    },
    // 取消发布
    unpublish(row, index) {
      this.$confirm('是否确定取消发布?', '取消发布', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.put("/message/unPublish", null, {
          params: {
            id: row.id,
          }
        }).then(res => {
          this.onLoad("", "", this.searchkey);
          this.$message({
            type: 'success',
            message: '取消发布!'
          });
        }).catch(error => {
          this.$message.error(error.msg)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '未改变任何操作'
        });
      });
    },
    // 搜索查询
    searchChange(params, done) {
      // console.log(params);
      this.searchkey = params;
      params.publish_department_code = this.jgvalue;
      typeof done === "function" && done();
      this.onLoad(1, "", params);
    },
    // 新增-保存 或者 查看-编辑 事件
    addSaveData(id) {
      if (id) {
        if (this.adddata.title && this.adddata.text) {
          this.$http.put("/message/saveOrUpdate", null, {
            params: this.adddata
          }).then(res => {
            this.onLoad();
            this.addFlag = false;
            Object.assign(this.adddata, { id: null, text: null, title: null });
            // console.log(this.adddata);          
          }).catch(error => {
            this.$message.error(error.msg);
          })
        } else {
          this.$notify({
            title: '提示',
            message: '标题和描述不能为空',
            type: 'warning'
          });
        }
      } else {

        if (this.adddata.title && this.adddata.text) {
          this.$http.post("/message/saveOrUpdate", null,
            {
              params: this.adddata
            }).then(res => {
              this.onLoad();
              this.addFlag = false;
            }).catch(error => {
              this.$message.error(error.msg);
            })
        } else {
          this.$notify({
            title: '提示',
            message: '标题和描述不能为空',
            type: 'warning'
          });
        }
      }
    },
    // 选择每页展示条数
    sizeChange(val) {
      this.onLoad("", val, this.searchkey);
    },
    // 翻页
    currentChange(val) {
      this.onLoad(val, "", this.searchkey);
    },
    // 分页查询
    onLoad(pageNum, pageSize, params) {
      if (pageNum) this.page.currentPage = pageNum;
      if (pageSize) this.page.pageSize = pageSize;
      params = params || null;
      let fenye = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.loading = true;
      this.$http.get("/message/query", {
        params: Object.assign(fenye, params)
      }).then(res => {
        this.zhanneixinData = res.data.records;
        this.page.total = res.data.total || res.data.records.length;
        this.loading = false;
      })
    },
    // 日期
    crtTimeFtt(val) {
      if (val != null) {
        var date = new Date(val);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        return `${year}-${month}-${day}`
      }
    },

    // 点击标题查看或修改发布内容
    rowEdit(row, column, cell, event) {
      // console.log(row);
      // console.log(column);
      // console.log(cell);
      if (column.label === "标题") {
        // console.log(row);
        this.addFlag = true;
        this.$http.get("/message/get", {
          params: {
            id: row.id
          }
        }).then(res => {
          // console.log(res)
          this.adddata = {
            text: res.data.text,
            title: res.data.title,
            id: res.data.id
          }
        }).catch(error => {
          this.$message.error(error.msg);
          this.$Log.capsule('查看-失败', error, 'danger')
        })
      }
    },
    // 清空搜索框
    searchReset() {
      this.jgvalue = ''
    }

  },
  mounted() {
    this.onLoad();

    this.$http.post("/org/list", {
      "entity": {},
    }).then(res => {
      // console.log(res);
      let arrData = [];
      res.data.forEach(element => {
        arrData.push({
          label: element.name,
          value: element.orgCode
        })
      });
      this.jgoptions = arrData;
      // console.log(arrData);
    })
  },
}
</script>

<style lang="scss" scoped>
.station-letter {
  padding: 20px 20px 100px;
  background-color: #fff;
  :deep(.avue-form__menu--center) {
    text-align: left;
  }
  :deep(.avue-crud__title) {
    height: 30px;
  }
}
</style>